import React from 'react';
import LoginForm from '../components/auth/LoginForm';
import AuthPageLayout from '../components/auth/AuthPageLayout';

const Login = () => (
  <AuthPageLayout>
    <LoginForm />
  </AuthPageLayout>
);

export default Login;
